import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum AccountStatusIds {
  ACTIVE = 1,
  FIRED = 2,
  KAPUT = 3,
}

export function getAccountStatii(): ISelectItem[] {
  return [
    { id: AccountStatusIds.ACTIVE, label: 'Active' },
    { id: AccountStatusIds.FIRED, label: 'Fired' },
    { id: AccountStatusIds.KAPUT, label: 'Kaput' },
  ]
}

export const getAccountStatusByLabel = getItemByLabelFactory(getAccountStatii)
export const getAccountStatusById = getItemByIdFactory(getAccountStatii)
